<template>
  <div id="app" oncontextmenu="return false">
    <RootUI />
  </div>
</template>

<script>
import RootUI from './components/RootUI.vue';

export default {
  name: 'app',
  components: {
    RootUI,
  },
};
</script>

<style>
html {
  height: 100%;
  user-select: none; /* We don't want users to be able to select the images */
  /* Remove grey highlight on iOS when user taps on images */
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-touch-callout: none; /* Disable tap-to-copy */
}
body {
  background: #fff;
  height: 100%;
  margin: 0;
}
#app {
  font-family: 'Avenir Next', 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
  /*
  UI is horizontally scrollable on Pixel devices without overflow hidden
  - https://jira.sc-corp.net/browse/BM-6117;
  */
  overflow: hidden;
}
:root {
  --top-half-height: 48%;
  /*
    5% of entire viewport height. Cannot use '5%' because the percentage data type is
    relative to the parent. In this case 5% of the parent isn't what we want and we want
    5% of the viewport.
  */
  --category-title-height: 5vh;
  --bottom-bar-height: 45px;

  --selfie-preview-height: 82px;
  --selfie-preview-width: 62px;
}

@media (prefers-color-scheme: dark) {
  body {
    background-color: #121212;
  }
}
</style>
